import { MutableRefObject, useRef } from 'react';

import type { CameraSnapshot } from './pathtracer/engine.ts';

/**
 * Stable ref that bridges camera state from R3F (WebGL) to the WebGPU overlay.
 * Create in a parent of both CameraBridge and RealTimeRenderOverlay, then pass
 * the same ref to each. The path tracer runs from `CameraBridge`'s useFrame after
 * the snapshot is written (see `afterCamera` + `pathTracerFrameRef`).
 */
export function useCameraSnapshotRef(): MutableRefObject<CameraSnapshot | null> {
  return useRef<CameraSnapshot | null>(null);
}
